<footer class="ib-footer" class="u-mt-none">
	<div class="container">
		<div class="row">
			<div ng-class="col-xs-12">
				<div class="ib-footer__box ib-footer__box--degraded">
					<div class="container">
						<div class="row">
							<div class="col-lg-2 col-md-12 col-sm-12 col-xs-12">
								<figure class="ib-footer__box-fig hidden-md hidden-sm hidden-xs">
									<img [src]="iconUrl + '/iberia/iberia-logo.png'" alt="Logo Iberia" class="ib-footer__box-img">
								</figure>
							</div>
							<div class="col-lg-10 col-md-12 col-sm-12 col-xs-12">
								<div class="row">
									<div class="col-xs-12">
										<span class="ib-footer__box-text">{{'FOOTER_PHONE_BILL_SALE_TEXT' | translate}}</span>
										<span class="ib-footer__box-text ib-footer__box-text--phone">(+34) 901 111 500</span>
									</div>
									<div class="col-xs-12">
										<a href="#" title="{{'FOOTER_ACCESSIBILITY_TEXT' | translate}}" class="ib-footer__box-link">{{'FOOTER_ACCESSIBILITY_TEXT' | translate}}</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="ib-footer__box ib-footer__box--copyright">
					<div class="container">
						<div class="row">
							<div class="col-xs-6">
								<span class="ib-text">&copy; Iberia 2016</span>
							</div>
							<div class="col-xs-6">
								<figure class="ib-footer__box-fig ib-footer__box-fig--to-right hidden-xl hidden-lg">
									<img [src]="iconUrl + '/pie/iberia-logo-footer.png'" alt="Logo Iberia" class="ib-footer__box-img" />
								</figure>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</footer>